import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AnnouncementBar } from './AnnouncementBar';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { WhatsAppFab } from './WhatsAppFab';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="min-h-screen flex flex-col bg-midnight text-beige font-sans relative overflow-x-hidden" data-id="element-130">
      <AnnouncementBar data-id="element-131" />
      <Navbar data-id="element-132" />
      <main className="flex-grow relative z-10" data-id="element-133">{children}</main>
      <Footer data-id="element-134" />
      <WhatsAppFab data-id="element-135" />
    </div>;
}